/**
 * ProShip Design System — Spacing (Foundation Layer)
 */
export const RADIUS = {
  sm: 1,
  md: 1.5,
  lg: 2,
  xl: 3,
  pill: '999px',
}

export const PAD = {
  page: {xs: 1.5, md: 2.5},
  card: {xs: 2, md: 2.5},
  section: 2,
}

export const GAP = {
  xs: 0.5,
  sm: 1,
  md: 1.5,
  lg: 2,
}
